module.exports = __webpack_public_path__ + "img/results.fb01b08c.svg";